import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";


declare var ko: any;

export class txnInitSplitEdit_template extends vnTemplate {

    public brandSelector: filterDropdown_template;
    public userSelector: filterAutoComplete_template;


    protected getTemplateHtml(): string {

        return `
                               
            <div class="form-header">
                <input type="hidden">
                               
                <!-- ko ifnot: isEdit() -->
                <h3 class="form-title icon i-transaction">Add Transaction Initiative Split</h3>
                <!-- /ko -->
                
                <!-- ko if:isEdit() -->
                <h3 class="form-title icon i-transaction">Edit Transaction Initiative Split</h3>
                <!-- /ko -->

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close" type="button"></button>
            </div>
            
        
            
            <div  id="view-results" class="form-body edit"> 
                  
                <div class="form-group row"  data-bind="visible: isEdit() == false">
                    <label class="form-label" for="" >Brand</label> 
                    ` + this.brandSelector.getHtmlBuild() + `      
                </div>
                
                <div class="form-group" data-bind="visible: isEdit() == false">
                    ` + this.userSelector.getHtmlBuild() + `
                </div>
                    
                <!-- ko if:isEdit() -->
                <div class="form-group" data-bind="using: brand" style="margin-bottom: 1rem;">
                   <span class="form-label" data-bind="text: name, css: iconImage"></span>
                </div> 
                <div class="form-group" >
                    <hr />
                </div>
                <div class="form-group" >
                    <span class="form-label icon i-user" data-bind="text: userName"></span>
                </div> 
                <div class="form-group" >
                    <hr />
                </div>
                <!-- /ko -->  
                    
                 <div class="form-group" data-bind="visible: initiativeSelectorVisible()">
                    <legend class="form-legend">Initiatives</legend>
                    <div data-bind="foreach: initiativeSplits"> 
                        
                        
                        <div class="row">
                            
                            <input data-bind="value: idInitiative, checked: checked, attr:{id: 'initiative_' + idInitiative}, event: { click: $parent.onClickCheckbox.bind($data)}" type="checkbox">

                            <label class="form-label icon i-check" data-bind="text: name, attr:{for: 'initiative_' + idInitiative}"></label>        
                            <input class="input-text num" type="text" oninput="this.value=this.value.replace(/[^0-9,.]/g,'');" data-bind="value: split, enable: checked"/>
                            <span>%</span>
                        </div>
                        
                      </div>
                  </div>
             
                <div class="form-footer">
                    <button class="btn" type="button" data-bind="click: onClickCancel">Cancel</button>
                    <button class="btn highlight" type="button" data-bind="click: onClickSave">Save</button>
                </div>

            </div>
            `;
    }

    protected initPartial(): void {

        this.brandSelector= new filterDropdown_template("brandSelector", this.getTemplateViewModel(), this.caller)

        this.userSelector = new filterAutoComplete_template("userSelector", this.getTemplateViewModel(), this.caller);
        this.userSelector.setIsVisible(1);
        this.userSelector.setPlaceHolderText("User");
    }

    protected getTemplateName(): string {
        return "txnInitSplitEdit_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "margin-top", "transaction-int"];
    }

    protected buildViewModel(): any {

        let myself = this;
        return {
            isEdit: ko.observable(0),
            brand: ko.observable({'name': '', 'iconImage':''}),
            userName: ko.observable(""),
            initiatives: ko.observableArray([]),
            initiativeSplits: ko.observableArray([]),
            initiativeSelectorVisible: ko.observable(0),
            onClickCheckbox: function (data, event) {
                myself.onClickCheckbox(data);
            },
            onClickSave: function (data, event) {
                myself.onClickSave();
            },
            onClickCancel: function (data, event) {
                myself.onClickCancel();
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            isEdit: this.getTemplateViewModel().isEdit,
            idBrand: this.getTemplateViewModel().brandSelector.selectedOption,
            idUser: this.getTemplateViewModel().userSelector.idSelectedItem,
            initiativeSplits: this.getTemplateViewModel().initiativeSplits,
        }
    }

    //
    // click on save button
    protected onClickCheckbox(data): void {

        let initiativeSplits = this.getTemplateViewModel().initiativeSplits();

        let item = initiativeSplits.find((i => i.idInitiative === data.idInitiative));

        if (item.checked){
            item.split = 0;
        }else {
            item.split = '';
        }
        this.getTemplateViewModel().initiativeSplits([]);

        this.getTemplateViewModel().initiativeSplits(initiativeSplits);
    }

    //
    // click on save button
    protected onClickSave(): void {

        this.caller.saveEditTxnInitSplit();
    }

    //
    // click on cancel button
    protected onClickCancel(): void {
        this.caller.cancelEditTxnInitSplit();
    }

    public setBrands(brands: Array<any>): void {

        brands.unshift({'id': 0, 'name' : '- Choose Brand -'});

        this.brandSelector.setOptions(brands);
        this.brandSelector.setLabel("Brand");
    }

    public setInitiatives(items){

        for (let item of items){
            item['name'] = item['initiative'];
        }
        this.getTemplateViewModel().initiatives(items);
    }

    public validateInitiativeSelector() {

        if (this.getTemplateViewModel().brandSelector.selectedOption() > 0 && this.getTemplateViewModel().userSelector.idSelectedItem() != null) {

            this.getTemplateViewModel().initiativeSelectorVisible(1);
        }else {

            this.getTemplateViewModel().initiativeSelectorVisible(0);
            this.setInitiativeSplits([]);
        }
    }

    public setBrand(brand) {

        this.getTemplateViewModel().brand(brand);
        this.brandSelector.setSelectedOption(brand.id);
    }

    public setUser(user) {

        this.getTemplateViewModel().userName(user.fullName);
        this.userSelector.getTemplateViewModel().idSelectedItem(user.id);
        this.userSelector.getTemplateViewModel().nameSelectedItem(user.fullName);
        document.querySelector('#user-input-close_userSelector').classList.add('is-showing');
    }

    public setInitiativeSplits(sourceInitiativeSplits) {

        let initiatives = this.getTemplateViewModel().initiatives();
        let initiativeSplits = [];
        let initiativeSplitIds = [];
        for(let initiative of initiatives) {

            let tmp = {'checked': false, 'idInitiative': initiative.id, 'name': initiative.name, 'split': ''};


            let split = sourceInitiativeSplits.find(i => i.idInitiative === initiative.id);
            if (split) {

                tmp.checked = true;
                tmp.split = split.split;
            }

            initiativeSplits.push(tmp);
        }

        this.getTemplateViewModel().initiativeSplits([]);
        this.getTemplateViewModel().initiativeSplits(initiativeSplits);
    }

    public setUserSelectorItems(items){
        for (let item of items){
            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        this.userSelector.setItems(items);
    }

    //
    // error
    protected onUpdateError(status, data): void {
        console.log('onUpdateError' + status);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/txnInitSplitEdit_template.ts